module.exports = __webpack_public_path__ + "img/shangyun_pablic.b165bc17.png";